export const NonNullish = <T>(
  input: T | null | undefined,
): input is Exclude<T, null | undefined> => {
  return input !== null && input !== undefined;
};
